<template>
  <div>
    <video v-if="src" ref="video" width="320" height="240" controls>
      <source :src="src" type="video/mp4" />
    </video>
    <canvas ref="canvas" style="height: 100px; width: 100px"></canvas>
    {{ src }}
    <input v-on:change="change" type="file" />
    <div @click="cropClick">截图</div>
  </div>
</template>

<script>
export default {
  name: "MediaVideoPage",
  data() {
    return {
      src: "",
      // src: '/IMG_0031.MP4',
      src1: "/1.mov",
    };
  },
  methods: {
    cropClick() {
      const video = document.createElement("video");
      video.src = this.src;
      const canvas = this.$refs.canvas; // 创建一个画布
      setTimeout(() => {
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height); // getContext:设置画布环境；drawImage:画画
      }, 1000);
    },
    change(e) {
      try {
        this.src = URL.createObjectURL(e.target.files[0]);
        const video = document.createElement("video");
        video.src = this.src;
        const canvas = this.$refs.canvas; // 创建一个画布
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height); // getContext:设置画布环境；drawImage:画画
      } catch (e) {
        console.log("e");
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
